(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* ── Mobile carousel — manual prev / next ──────────────────────────────── */
  class AnnBarCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ann-bar__slide'));
      this.current = 0;
      this.querySelector('.ann-bar__nav--prev')?.addEventListener('click', () => this.step(-1));
      this.querySelector('.ann-bar__nav--next')?.addEventListener('click', () => this.step(1));
    }

    step(dir) {
      this.slides[this.current].classList.remove('ann-bar__slide--active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.current = (this.current + dir + this.slides.length) % this.slides.length;
      this.slides[this.current].classList.add('ann-bar__slide--active');
      this.slides[this.current].setAttribute('aria-hidden', 'false');
    }
  }
  customElements.define('ann-bar-carousel', AnnBarCarousel);

  /* ── Desktop rotator — auto-advancing, pauses on hover ─────────────────── */
  class AnnBarRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ann-bar__slide'));
      if (this.slides.length <= 1) return;
      this.current = 0;
      this._ms = parseInt(this.dataset.interval || '4000', 10);
      this._start();
      this.addEventListener('mouseenter', () => this._stop());
      this.addEventListener('mouseleave', () => this._start());
    }

    disconnectedCallback() {
      this._stop();
    }

    _start() {
      this._stop();
      this._timer = setInterval(() => this._advance(), this._ms);
    }

    _stop() {
      clearInterval(this._timer);
    }

    _advance() {
      this.slides[this.current].classList.remove('ann-bar__slide--active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.current = (this.current + 1) % this.slides.length;
      this.slides[this.current].classList.add('ann-bar__slide--active');
      this.slides[this.current].setAttribute('aria-hidden', 'false');
    }
  }
  customElements.define('ann-bar-rotator', AnnBarRotator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── StickyHeader (Dawn) ─────────────────────────────────────────────────── */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && !this.preventReveal) {
        this.dispatchEvent(new CustomEvent('preventHeaderReveal', { bubbles: true }));
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(this.hide.bind(this), 500);
        this.preventReveal = true;
      } else if (scrollTop < this.currentScrollTop) {
        this.reveal();
        this.preventReveal = false;
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /* ── BcNavDrawer ─────────────────────────────────────────────────────────── */
  class BcNavDrawer extends HTMLElement {
    connectedCallback() {
      // Guard: moving a custom element triggers connectedCallback again.
      // Only proceed with initialisation once we are already in <body>.
      if (this.parentElement !== document.body) {
        document.body.appendChild(this); // fires connectedCallback a second time
        return; // skip init here; it runs in that second call
      }

      this._hamburger = document.querySelector('.bc-header__hamburger');
      this._backdrop = document.querySelector('.bc-nav-backdrop');

      // Move backdrop to body as well (plain div — no recursion risk)
      if (this._backdrop) document.body.appendChild(this._backdrop);

      this._hamburger?.addEventListener('click', () => this.open());
      this.querySelector('[data-bc-nav-close]')?.addEventListener('click', () => this.close());
      this._backdrop?.addEventListener('click', () => this.close());
      this.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    open() {
      this.removeAttribute('aria-hidden');
      this.setAttribute('open', '');
      this._hamburger?.setAttribute('aria-expanded', 'true');
      this._backdrop?.classList.add('is-active');
      document.body.classList.add('bc-drawer-open');
      // Defer focus so element is visible first
      requestAnimationFrame(() => this.querySelector('[data-bc-nav-close]')?.focus());
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      this.removeAttribute('open');
      this._hamburger?.setAttribute('aria-expanded', 'false');
      this._backdrop?.classList.remove('is-active');
      document.body.classList.remove('bc-drawer-open');
      this._hamburger?.focus();
    }
  }
  customElements.define('bc-nav-drawer', BcNavDrawer);

  /* ── Sticky header (all viewports) ──────────────────────────────────────── */
  /*
   * position:sticky on a CSS Grid item is bounded by its grid row — body uses
   * display:grid so the header's auto-height row (~60–100px) is the containing
   * block, and sticky releases the instant that row scrolls off screen.
   * This affects both mobile AND desktop equally.
   *
   * Fix: measure the exact document distance to the header bar's top edge
   * (automatically accounts for any announcement bar above it), then switch to
   * position:fixed at that threshold. A same-height spacer div inserted before
   * the header keeps the document flow intact so the page doesn't jump.
   */
  (function bcStickyHeader() {
    var hdr = document.querySelector('.bc-header-wrapper');
    if (!hdr) return;

    // Distance from document top to the header bar's top edge
    var threshold = Math.round(hdr.getBoundingClientRect().top + window.pageYOffset);

    // Spacer preserves header height in the flow while it is fixed
    var spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.cssText = 'height:' + hdr.offsetHeight + 'px;display:none;pointer-events:none;';
    hdr.parentNode.insertBefore(spacer, hdr);

    var isFixed = false;

    function update() {
      var shouldFix = window.pageYOffset >= threshold;
      if (shouldFix === isFixed) return;
      isFixed = shouldFix;
      hdr.classList.toggle('bc-header--fixed', isFixed);
      spacer.style.display = isFixed ? 'block' : 'none';
    }

    update(); // handle page loads that start mid-scroll
    window.addEventListener('scroll', update, { passive: true });

    window.addEventListener('resize', function () {
      // Recalculate after layout changes (orientation flip, drawer open, etc.)
      threshold = Math.round(hdr.getBoundingClientRect().top + window.pageYOffset);
      spacer.style.height = hdr.offsetHeight + 'px';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
